import { snakeStore, DATA, SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
import { WorksheetService } from '@pbx/services/WorksheetService';

export const table = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'updated_at',
      [SORT_DIRECTION]: 'desc'
    },
    actions: {
      getData: (_, params) => WorksheetService.getList(params),

      updateItemById: ({ getters, commit }, modify_item) => {
        const data_in_store = getters[DATA] || [];

        const modify_data = data_in_store.map(store_item => {
          if (store_item.id === modify_item.id) {
            return { ...store_item, ...modify_item };
          } else {
            return store_item;
          }
        });

        commit(DATA, modify_data);
      }
    }
  },
  true
);
